import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { PdfJsViewerModule } from "@kariudo/ng2-pdfjs-viewer"

import { SharedModule } from "../../shared/shared.module";
import { LiquidElementComponent } from "./liquid-element/liquid-element.component";
import { LiquidPageComponent } from "./liquid-page.component";
import {
  LiquidTextComponent,
  LiquidImageComponent,
  LiquidVideoComponent,
  LiquidPdfComponent,
} from "./liquid-element/types/liquid-element-types.index";
import { LiquidCutComponent } from "./liquid-cut/liquid-cut.component";
import { SelectedTextDirective } from "./selected-text.directive";
import { LiquidTooltipComponent } from "./liquid-tooltip/liquid-tooltip.component";

@NgModule({
  declarations: [
    LiquidElementComponent,
    LiquidPageComponent,
    LiquidTextComponent,
    LiquidImageComponent,
    LiquidVideoComponent,
    LiquidPdfComponent,
    LiquidCutComponent,

    SelectedTextDirective,
    LiquidTooltipComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    SharedModule,
    PdfJsViewerModule,
  ],
  providers: [],
  exports: [
    LiquidElementComponent,
    LiquidPageComponent,
    LiquidTextComponent,
    LiquidImageComponent,
    LiquidVideoComponent,
    LiquidPdfComponent,
    LiquidCutComponent,
    SelectedTextDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LiquidPageModule {

}
